<template lang="pug">
//- TODO:リファクタリングする
.voice#voice
  .fadeup
    h2.l-container.is-lg
      | VOICE
      span 受講生の声
    .voice-list.l-container.is-lg
      .voice-item(v-for="list in filteredVoices" :key="list.id")
        template(v-if="list.course == 1")
          a.external_link.voice-item-thumb(:href="`${$urls.vook}/n/${list.link}`" :id="`vg-voice${list.id}`" target="_blank")
            img(v-lazy="require(`~/assets/images/school/voice/${current}/voice-thumb${list.id}.jpg`)"   :alt="`${list.title}`" width="1200" height="630")
        template(v-if="list.course == 2")
          a.external_link.voice-item-thumb(:href="`${$urls.vook}/n/${list.link}`" :id="`mg-voice${list.id}`" target="_blank")
            img(v-lazy="require(`~/assets/images/school/voice/${current}/voice-thumb${list.id}.jpg`)" :alt="`${list.title}`" width="1200" height="630")
        .voice-item-title
          p
            | {{ list.title }}
        .voice-item-user
          .voice-item-user-img(v-if="list.course == 2")
            //- MEMO:mgのみ表示（リファクタリング対象）
            img(v-lazy="require(`~/assets/images/school/voice/${current}/voice-icon${list.id}.png`)" :alt="`${list.name}`" width="60" height="60")
          .voice-item-user-text
            .voice-item-user-text-age(v-if="list.course == 1")
              //- MEMO:vgのみ表示（リファクタリング対象）
              | {{ list.age }}
            .voice-item-user-text-career
              | {{ list.career }}
            .voice-item-user-text-name
              | {{ list.name }}
</template>

<script>
export default {
  props: {
    current: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      voice_lists_videographer: [
        {
          id: '1',
          course: '1',
          link: '6297',
          title: '卒業生インタビュー：類瀬直さん',
          age: '40代女性',
          career: '(前職)事務、(現在)事務 兼 ビデオグラファー',
          name: '類瀬直さん'
        },
        {
          id: '2',
          course: '1',
          link: '6318',
          title: '卒業生インタビュー：鈴木徹さん',
          age: '30代男性',
          career: '(前職)医療従事者、(現在)会社経営',
          name: '鈴木徹さん'
        }
      ],
      voice_lists_motiongraphics: [
        {
          id: '1',
          course: '2',
          link: '6197',
          title: '卒業生インタビュー：ぽこたぽこさん',
          career: 'イラストレーター、Lottie(ロッティー)アニメーター',
          name: 'ぽこたぽこさん'
        },
        {
          id: '10',
          course: '2',
          link: '7011',
          title: '一途にスクール受講ができる人にはおすすめ',
          career: '会社員（製品企画）',
          name: 'TKさん'
        },
        {
          id: '2',
          course: '2',
          link: '6637',
          title: 'Vook schoolで挑戦する未経験からの映像制作、その魅力とは？',
          career: '大学生',
          name: '今井のぞみさん'
        },
        {
          id: '3',
          course: '2',
          link: '6639',
          title:
            '映像制作経験者がなぜスクールへ？学び直しで、表現の幅を広げる。',
          career: 'モーションアニメーター',
          name: '比楽健太(フシギナ)さん'
        },
        {
          id: '5',
          course: '2',
          link: '6743',
          title:
            '産休取得を機に、スクール入校を決意。休職期間で本業×モーショングラファーとして新たなキャリアを築く！',
          career: '会社員（人事）',
          name: 'ふじいもとさん'
        },
        {
          id: '6',
          course: '2',
          link: '6722',
          title:
            '憧れのモーショングラファーとして副業！デザイナーがAfter Effectsでステップアップを目指す',
          career: '会社員（プロダクトデザイナー）',
          name: 'monchi.さん'
        },
        {
          id: '9',
          course: '2',
          link: '6989',
          title:
            '知識が力になる。未経験で映像制作 ”現場のニュアンス”が分からなかったが、実践で学び現場スタッフと会話できるように',
          career: '会社員（映像制作会社）',
          name: 'まなやさん'
        },
        {
          id: '4',
          course: '2',
          link: '6701',
          title:
            '所属する会社でアニメーション案件を初受注！スキルアップで、代表からも「提案の幅が広がった」と嬉しい評価。',
          career: '会社員（アニメーション制作）',
          name: '中山陽子さん'
        },
        {
          id: '8',
          course: '2',
          link: '7192',
          title:
            '未経験から映像制作会社のモーショングラフィッカー！社員研修で出会ったVook schoolが大きな転機に。',
          career: '会社員（映像制作会社）',
          name: 'やましたまゆこさん'
        },
        {
          id: '7',
          course: '2',
          link: '7164',
          title:
            'システムエンジニアから映像クリエイターへ！業界未経験から転職成功の秘訣とは？',
          career: '会社員（映像制作会社）',
          name: '林裕人さん'
        },
        {
          id: '11',
          course: '2',
          link: '7234',
          title:
            'マーケター→クリエイターへの転身で、インハウス動画制作チームを立ち上げる。成功の理由は「学びをチームへも即時還元した」こと',
          career: '会社員（マーケター→映像クリエイター）',
          name: 'やまぐちさん'
        },
        {
          id: '12',
          course: '2',
          link: '7740',
          title:
            'ポートフォリオ制作でキャリアを拓く！愚直にチャンスに挑む姿勢が、フリーランスとしての独立に繋がった。',
          career: '映像クリエイター',
          name: '稲垣朋弘（ともぞー）さん'
        },
        {
          id: '13',
          course: '2',
          link: '7892',
          title:
            '未経験でスクールに入校し、わずか10ヶ月で転職を成功させ辿り着いた映像業界',
          career: '映像制作会社 勤務',
          name: '十河直幸さん'
        }
      ],
      filteredVoices: []
    }
  },
  mounted() {
    if (this.current === 'videographer') {
      if (this.theme === 'pickup') {
        this.filteredVoices = this.shuffle(this.voice_lists_videographer).slice(
          0,
          3
        )
      } else {
        this.filteredVoices = this.voice_lists_videographer.slice().reverse()
      }
    } else if (this.current === 'motiongraphics') {
      if (this.theme === 'pickup') {
        this.filteredVoices = this.shuffle(
          this.voice_lists_motiongraphics
        ).slice(0, 3)
      } else {
        this.filteredVoices = this.voice_lists_motiongraphics.slice().reverse()
      }
    }
  },
  methods: {
    openModal(name) {
      this.$modal.show(name)
    },
    shuffle(array) {
      const copy = array
      for (let i = copy.length - 1; i > 0; i--) {
        const r = Math.floor(Math.random() * (i + 1))
        const tmp = copy[i]
        copy[i] = copy[r]
        copy[r] = tmp
      }
      return copy
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/individual/school/school2023.scss';

.voice {
  h2 {
    margin-bottom: 50px;
  }
  &-list {
    @include media(pc) {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      @include flex_3column;
    }
    .voice-item {
      @include media(sp) {
        margin-bottom: 20px;
      }
      p {
        @include media(sp) {
          line-height: 1.5;
        }
      }
      @include media(pc) {
        width: 32%;
        margin-bottom: 4%;
      }
      @include media(sp) {
        margin-bottom: 30px;
      }
    }
  }
  &-item {
    &-thumb {
      position: relative;
      margin-bottom: 16px;
      border: solid 1px #ddd;
      @include hover_thumb();
      //- MEMO:OGP画像だがトリミングで余白が生まれてしまうため52%
      padding-top: 52%;
      &-course {
        @include course-label();
      }
      img {
        vertical-align: bottom;
      }
    }
    &-title {
      padding-bottom: 18px;
      border-bottom: solid 1px #ddd;
      p {
        font-size: 17px;
        font-weight: bold;
        line-height: 1.8;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
    &-user {
      padding-top: 20px;
      display: flex;
      @include media(sp) {
        margin-bottom: 10px;
      }
      &-img {
        width: 60px;
        margin-right: 20px;
      }
      &-text {
        flex: 1;
        display: flex;
        justify-content: center;
        flex-direction: column;
        &-age {
          font-weight: bold;
          margin-bottom: 8px;
        }
        &-career {
          color: #999999;
          font-size: 13px;
          margin-bottom: 8px;
        }
        &-name {
          color: #999999;
          font-size: 13px;
        }
      }
    }
  }
}
</style>
